import React, { useState } from 'react';
import BeneficiaryDocumentsList from './BeneficiaryDocumentsList';
import BeneficiaryDocumentViewer from './BeneficiaryDocumentViewer';
import BeneficiaryDocumentGenerator from './BeneficiaryDocumentGenerator';
import './BeneficiaryDocumentsManager.css';

/**
 * Gestionnaire principal des documents bénéficiaires
 * Intègre la liste, la visualisation et la génération de documents
 */
const BeneficiaryDocumentsManager = ({ db, user, beneficiaryId, isClientView = false }) => {
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [showGenerator, setShowGenerator] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [viewMode, setViewMode] = useState('list'); // 'list' ou 'viewer'

  const handleDocumentSelect = (document) => {
    setSelectedDocument(document);
    setViewMode('viewer');
  };

  const handleCloseViewer = () => {
    setSelectedDocument(null);
    setViewMode('list');
  };

  const handleDocumentGenerated = (documentId) => {
    setShowGenerator(false);
    // Recharger la liste des documents
    setRefreshTrigger(prev => prev + 1);
  };

  const handleDocumentUpdated = () => {
    // Recharger la liste des documents
    setRefreshTrigger(prev => prev + 1);
    // Recharger le document actuellement affiché
    if (selectedDocument) {
      // On pourrait recharger le document ici
      setRefreshTrigger(prev => prev + 1);
    }
  };

  return (
    <div className="beneficiary-documents-manager">
      {/* Vue principale */}
      <div className={`manager-content ${viewMode === 'viewer' ? 'viewer-mode' : 'list-mode'}`}>
        {/* Liste des documents (sidebar en mode viewer) */}
        <div className={`documents-list-panel ${viewMode === 'viewer' ? 'sidebar' : 'full'}`}>
          <BeneficiaryDocumentsList
            db={db}
            beneficiaryId={beneficiaryId}
            onDocumentSelect={handleDocumentSelect}
            onGenerateNew={!isClientView ? () => setShowGenerator(true) : null}
            refreshTrigger={refreshTrigger}
            isClientView={isClientView}
          />
        </div>

        {/* Viewer (affiché si un document est sélectionné) */}
        {viewMode === 'viewer' && selectedDocument && (
          <div className="document-viewer-panel">
            <BeneficiaryDocumentViewer
              db={db}
              document={selectedDocument}
              beneficiaryId={beneficiaryId}
              onClose={handleCloseViewer}
              onDocumentUpdated={handleDocumentUpdated}
              allowActions={true}
              isClientView={isClientView}
            />
          </div>
        )}
      </div>

      {/* Modal de génération - uniquement pour les administrateurs */}
      {showGenerator && !isClientView && (
        <BeneficiaryDocumentGenerator
          db={db}
          user={user}
          onClose={() => setShowGenerator(false)}
          onDocumentGenerated={handleDocumentGenerated}
        />
      )}
    </div>
  );
};

export default BeneficiaryDocumentsManager;
